export default "__VITE_ASSET__C2RT3G1c__"